import React from 'react';
import './Todo.css';

const Privacy: React.FC = () => {
  return (
    <div className="app">
      {/* This is me */}
      <h1 className="home-header text-large">
        {`// TODO`}
      </h1>

      {/* Main page content, centered */}
      <div className="centered-container">
        <h2 className="text-large">
          Privacy Policy
        </h2>

        <p className="text-medium">
          {`// TODO`} does not collect any of your data.
        </p>
      </div>

    </div>
  );
};

export default Privacy;
